import { useState, useEffect } from 'react';
export default function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'system');
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else if (theme === 'light') root.classList.remove('dark');
    else {
      window.matchMedia('(prefers-color-scheme: dark)').matches
        ? root.classList.add('dark') : root.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);
  useEffect(() => {
    if (theme !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const h = e => e.matches ? document.documentElement.classList.add('dark') : document.documentElement.classList.remove('dark');
    mq.addEventListener('change', h);
    return () => mq.removeEventListener('change', h);
  }, [theme]);
  return { theme, setTheme };
}
